<template>
    <div class="header">
        <div class="wrap fix">
            <div class="logo-img fix l" onclick="javascript:window.open('/')">
                <img class="logo l" :src="logo" alt="皇家加勒比国际豪华游轮">

            </div>
            <div class="nav l">
                <ul class="fix">
                    <li>
                        <span>中国出发航线</span>
                        <div class="sub-nav slideInDownNavMenu">
                            <div class="sub-nav-wrap">
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.cruise/cruisesearch/search" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/hp.png" alt=""></span>全部航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.cruise/cruisesearch/search?offset=0&saildays=6" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/hp-long.png" alt=""></span>深度游航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.cruise/cruisesearch/search?offset=0&saildates=2020-04,2020-05,2020-06" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/hp-weekend.png" alt=""></span>超凡暖春航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.cruise/cruisesearch/search?offset=0&tags=%e6%98%a5%e8%8a%82,%e7%ab%af%e5%8d%88,%e5%9b%bd%e5%ba%86,%e5%9c%a3%e8%af%9e%e8%8a%82,%e5%85%83%e6%97%a6,%e9%99%a4%e5%a4%95,%e6%83%85%e4%ba%ba%e8%8a%82,%e5%85%83%e5%ae%b5%e8%8a%82,%e4%ba%94%e4%b8%80,%e6%af%8d%e4%ba%b2%e8%8a%82,%e4%b8%83%e5%a4%95,%e4%b8%ad%e7%a7%8b,%e5%af%92%e5%81%87,%e6%9a%91%e5%81%87,%e8%b8%8f%e9%9d%92" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/hp-spring.png" alt=""></span>超凡假日航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.cruise/cruisesearch/search?offset=0&tags=%e8%b6%85%e5%87%a1%e4%b8%9c%e4%ba%ac&orderbysaildate=1" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/hp-tokyo.png" alt=""></span>精彩东京航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/faq" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/faq.png" alt=""></span>常见问题</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>海外出发航线</span>
                        <div class="sub-nav slideInDownNavMenu">
                            <div class="sub-nav-wrap">
                                <div class="sub-nav-item">
                                    <a href="https://www.rclrow.com/cruise/search" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/row-all.png" alt=""></span>全部航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rclrow.com/cruise/search?departurecodes=sin" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/row-sin.png" alt=""></span>东南亚航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rclrow.com/cruise/search?departurecodes=mia,fll,pcn" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/row-caribean.png" alt=""></span>加勒比航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rclrow.com/cruise/search?departurecodes=bcn,rom,vce" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/row-europe.png" alt=""></span>欧洲航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rclrow.com/cruise/search?offset=0&departurecodes=sea,swd,yvr" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/row-alaska.png" alt=""></span>阿拉斯加航线</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rclrow.com/cruise/search?offset=0&departurecodes=syd,bne" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/row-aus.png" alt=""></span>澳新航线</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>皇家船队</span>
                        <div class="sub-nav slideInDownNavMenu">
                            <div class="sub-nav-wrap">
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/taste/ships/sc" target="_blank">
                                        <span>
                                            <img src="https://resource.rcclchina.com.cn/nav/new/sc.png" alt="">
                                        </span>海洋光谱号(上海/香港)
                                    </a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/taste/ships/vy" target="_blank">
                                        <span><img src="https://resource.rcclchina.com.cn/nav/new/qn.png" alt=""></span>
                                        海洋航行者号(天津)
                                    </a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/taste/ships/qn" target="_blank">
                                        <span><img style="margin-top: 0px;" src="https://resource.rcclchina.com.cn/nav/new/row-sin.png" alt=""></span>
                                        海洋量子号(新加坡)
                                    </a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/symphony-of-the-seas/index" target="_blank">
                                        <span><img src="https://resource.rcclchina.com.cn/nav/new/sy.png" alt=""></span>
                                        海洋交响号(迈阿密)
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>皇家游轮体验</span>
                        <div class="sub-nav slideInDownNavMenu">
                            <div class="sub-nav-wrap">
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.custompage/country/countrylist" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/shorex.png" alt=""></span>目的地/岸上观光</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/taste/taste" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/royalExperience.png" alt=""></span>超凡游轮体验</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/spectrum-of-the-seas/liveshow" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/kids.png" alt=""></span>超凡童趣 海上历奇</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/privilege/goldensuite20" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/vip-line.png" alt=""></span>皇家套房尊享</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.review/travel/tn-n-n-0-0-9.html" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/review.png" alt=""></span>游记攻略</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/mice" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/mice.png" alt=""></span>会奖旅游</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>皇家资讯</span>
                        <div class="sub-nav slideInDownNavMenu">
                            <div class="sub-nav-wrap">
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.custompage/rcclnews" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/news.png" alt=""></span>新闻中心</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/Rccl.UserCenter/CustomerInfo/SignUpReward" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/loyalty.png" alt=""></span>会员福利</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/brand/story" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/brand.png" alt=""></span>品牌故事</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/mice" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/mice.png" alt=""></span>商务会奖</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.hr/recruitment/index" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/recruitment.png" alt=""></span>人才招聘</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>已有预订</span>
                        <div class="sub-nav slideInDownNavMenu">
                            <div class="sub-nav-wrap">
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/faq" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/faq.png" alt=""></span>常见问题</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/rccl.booking/booking/bookingsearch" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/booking_search.png" alt=""></span>订单查询</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rclolci.com/rccl.olci/olci/checkinindex" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/olci.png" alt=""></span>在线值船</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.rcclchina.com.cn/content/brand/passenger/repeat" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/policy.png" alt=""></span>票据合同</a>
                                </div>
                                <div class="sub-nav-item">
                                    <a href="https://www.pcprcl.com/rccl.pcp/?hmsr=rcclchinapcweb&hmpl=topbar" target="_blank"><span><img src="https://resource.rcclchina.com.cn/nav/new/pcp.png" alt=""></span>皇家行前订</a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="nav_contact l">
                <div class="phoneCall l">
                    <img src="https://resource.rcclchina.com.cn/partner/phone.png" alt="">
                    <div>
                        <a class="phoneCall_info" href="javascript: void(0)" @click="handlerShow">400-820-7195</a>
                    </div>
                    <ServiceTel :showMask="isShowMask" @closeMask="handlerClose"></ServiceTel>
                </div>
                <div class="online_service l">
                    <img src="https://resource.rcclchina.com.cn/partner/online_service.png" alt="">
                    <a class="hold_link" href="javascript: void(0)" onclick="window.open('http://rcclchina.udesk.cn/im_client/?web_plugin_id=23600', 'newwindow', 'height=400, width=400')"></a>
                </div>

                <div class="weibo l" onclick="window.open('http://weibo.com/rcclchina')">
                    <img class="wb-img1" src="https://resource.rcclchina.com.cn/Home/new/weibo.png" alt="">
                    <img class="wb-img2" src="https://resource.rcclchina.com.cn/partner/weibo.png" alt="">
                </div>

                <div class="weixin l">
                  <img class="wx-img1" src="https://resource.rcclchina.com.cn/Home/new/weixin.png" alt="">
                  <img class="wx-img2" src="https://resource.rcclchina.com.cn/partner/weixin.png" alt="">
                  <div class="qrCode_container" style="width:500px;height:300px">
                    <div class="arrow"></div>
                    <div class="service_code">
                      <img
                          src="https://resource.rcclchina.com.cn/partner/site_top_qrcodes.jpg"  style="width:490px"
                          alt=""
                      />
                    </div>
                  </div>
                </div>
<!--                <div-->
<!--                    class="weixin weixinHover"-->
<!--                    @mouseenter="hoverWechat"-->
<!--                    @mouseleave="leaveHoverWechat"-->
<!--                >-->
<!--                  <img class="wx-img1" :src="wechatImage" alt="" />-->
<!--                  <div class="qrCode_container"  style="width:500px;height:300px">-->
<!--                    <div class="arrow"></div>-->
<!--                    <div class="service_code">-->
<!--                      <img-->
<!--                          src="https://resource.rcclchina.com.cn/partner/site_top_qrcodes.jpg"  style="width:490px"-->
<!--                          alt=""-->
<!--                      />-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="weixin l">-->
<!--                    <img class="wx-img1" src="https://resource.rcclchina.com.cn/Home/new/weixin.png" alt="">-->
<!--                    <img class="wx-img2" src="https://resource.rcclchina.com.cn/partner/weixin.png" alt="">-->
<!--                    <div class="qrCode_container">-->
<!--                        <div class="arrow"></div>-->
<!--                        <div class="service_code">-->
<!--                            <img src="https://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/weixin.jpg" alt="">-->
<!--                            <p>官方服务号</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="nav_login r">
                <div class="hasLogin">
                    <img class="loginLogo" :src="showImg(level, customerInfo.userIdentity)" alt="">
                    <a class="loginId" href="/Rccl.UserCenter/CustomerInfo/Info?IsHomePage=true">{{customerInfo.fullName}}</a>
                    <img class="inactiveArrow" :src="down" alt="Alternate Text">
                    <div class="loginMenu">
                        <div class="arrow"></div>
                        <ul>
                            <li>
                                <div class="loginIcon">
                                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/menu/myOrder.png" alt="">
                                </div>
                                <p>我的订单</p>
                                <a href="/Rccl.UserCenter/OrderRecord/List" class="hold_link"></a>
                            </li>
                            <li>
                                <div class="loginIcon">
                                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/menu/myCoupon.png" alt="">
                                </div>
                                <p>我的优惠券</p>
                                <a href="/Rccl.UserCenter/UserCoupon/UserCoupon" class="hold_link"></a>
                            </li>
                            <li>
                                <div class="loginIcon">
                                    <img style="" src="https://resource.rcclchina.com.cn/tui2/user_center/menu/myWishlist.png" alt="">
                                </div>
                                <p>我的收藏</p>
                                <a href="/Rccl.UserCenter/WishList/List" class="hold_link"></a>
                            </li>
                            <li>
                                <div class="loginIcon rewardIcon">
                                    <img style="" src="https://resource.rcclchina.com.cn/reward/side_bar_tb_home.png" alt="">
                                </div>
                                <p style="position: relative;left: -4px;">会员中心</p>
                                <router-link class="hold_link" to="/member/index" ></router-link>
                            </li>
                            <li>
                                <div class="loginIcon">
                                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/menu/logout.png" alt="">
                                </div>
                                <p>退出</p>
                                <a @click="logout()" href="/Users/Account/LogOff?ReturnUrl=%2fRccl.Cruise%2fCruiseSearch%2fSearch" class="hold_link"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import logo from '@/assets/images/logo.png'
    import down from '@/assets/images/down_tb.png'
    import ServiceTel from '@/components/service-tel'
    import { mapGetters, mapMutations } from 'vuex'
    import img_00 from '@/assets/images/loginLogo_00.png'
    import img_01 from '@/assets/images/loginLogo_01.png'
    import img_02 from '@/assets/images/loginLogo_02.png'
    import img_03 from '@/assets/images/loginLogo_03.png'
    import img_04 from '@/assets/images/loginLogo_04.png'
    export default {
        name: 'TopBar',
        props: [],
        components: {
            ServiceTel
        },
        data () {
            return {
                logo,
                down,
                isShowMask: false,
                level: 1,
                customerInfo: {},
                wechatImage: "https://resource.rcclchina.com.cn/partner/site_top_icons_gray.png",
            }
        },
        watch: {
            getInfo: function (newVal) {
                this.customerInfo = newVal
                this.level = this.getLevel(newVal.userLevel)
            }
        },
        computed: {
            ...mapGetters(['getInfo'])
        },
        mounted () {
            this.getLocalData()
        },
        methods: {
            ...mapMutations(['removeToken']),
            handlerShow () {
                this.isShowMask = true
            },
            handlerClose (data) {
                this.isShowMask = data
            },
            getLevel (userLevelText) {
                switch (userLevelText) {
                    case '初级会员':
                        return 1
                    case '高级会员':
                        return 2
                    case '精英会员':
                        return 3
                    case '卓越会员':
                        return 4
                }
            },
            showImg (level, userIdentity) {
                if (userIdentity !== '1') {
                    return img_00
                }
                switch (level) {
                    case 1:
                        return img_01
                    case 2:
                        return img_02
                    case 3:
                        return img_03
                    case 4:
                        return img_04
                }
            },
            getLocalData () {
                let info = window.localStorage.getItem('customerInfo')
                if (info) {
                    this.customerInfo = JSON.parse(info)
                    this.level = this.getLevel(this.customerInfo.userLevel)
                }
            },
            logout () {
                this.removeToken()
                window.location.href = '/Users/Account/LogOff?ReturnUrl=%2fRccl.Cruise%2fCruiseSearch%2fSearch'
                return false
            },
            hoverWechat() {
              this.wechatImage = "https://resource.rcclchina.com.cn/partner/site_top_icons.png";
            },
            leaveHoverWechat() {
              this.wechatImage =
                  "https://resource.rcclchina.com.cn/partner/site_top_icons_gray.png";
            }
        }
    }
</script>

<style lang="less" scoped>
    .header{
        height: 74px;
        background-color: #fff;
        .logo-img{
            width: 250px;
            padding-top: 11px;
            .logo{
                width: 150px;
            }
            .activity {
                position: relative;
                top: 10px;
                left: 5px;
                width: 100px;
                cursor: pointer;
            }
        }
        .nav{
            margin-left: 14px;
            li{
                float: left;
                position: relative;
                padding: 0 7px;
                margin-left: 13px;
                & >span{
                    display: flex;
                    display: -webkit-flex;
                    align-items: center;
                    -webkit-align-items: center;
                    font-size: 13px;
                    line-height: 74px;
                    cursor: pointer;
                    transition: all ease 0.3s;
                    -webkit-transition: all ease 0.3s;
                    -moz-transition: all ease 0.3s;
                    -o-transition: all ease 0.3s;
                    color: #747d80;
                    font-weight: 400;
                    // &::after{
                    //     content: "";
                    //     display: inline-block;
                    //     vertical-align: middle;
                    //     width: 12px;
                    //     height: 5px;
                    //     margin-left: 1px;
                    //     background: url("../../../assets/images/down.jpg") no-repeat;
                    //     transition: all ease 0.3s;
                    //     -webkit-transition: all ease 0.3s;
                    //     -moz-transition: all ease 0.3s;
                    //     -o-transition: all ease 0.3s;
                    // }
                }
                .sub-nav{
                    display: none;
                    position: absolute;
                    left: 50%;
                    top: 70px;
                    z-index: 99;
                    width: auto;
                    min-width: 134px;
                    border-top: 4px solid #fbc500;
                    background-color: rgba(13,125,193,0.95);
                    animation-duration: 0.5s;
                    -webkit-animation-duration: 0.5s;
                    -moz-animation-duration: 0.5s;
                    -o-animation-duration: 0.5s;
                    transform: translateX(-50%);
                    -webkit-transform: translateX(-50%);
                    -moz-transform: translateX(-50%);
                    -o-transform: translateX(-50%);
                    -ms-transform: translateX(-50%);
                    .sub-nav-wrap{
                        padding: 4px 0;
                        .sub-nav-item{
                            white-space: normal;
                            word-break: normal;
                            padding: 7px 15px;
                            a{
                                display: block;
                                width: auto;
                                color: #fff;
                                line-height: 27px;
                                white-space: nowrap;
                                span{
                                    display: inline-block;
                                    vertical-align: middle;
                                    width: 28px;
                                    img{
                                        margin-top: 3px;
                                    }
                                }
                            }
                            &:hover{
                                background-color: #1d99e5;
                            }
                        }
                    }
                }
                &:hover{
                    & >span{
                        color: #ffa70d;
                        &::after{
                            transform: rotateZ(180deg);
                            -webkit-transform: rotateZ(180deg);
                            -moz-transform: rotateZ(180deg);
                            -o-transform: rotateZ(180deg);
                            -ms-transform: rotateZ(180deg);
                        }
                    }
                    .sub-nav{
                        display: block;
                    }

                }
            }
        }
        .nav_contact{
            display: block;
            margin-left: 26px;
            margin-top:22px;
            //width: 210px;
            height: 28px;
            //background-color: #006ab9;
            border-radius: 5px;
            padding-left: 8px;
            .phoneCall{
                background: #006ab9;
                line-height: 28px;
                width: 114px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                img{
                    float: left;
                    margin-top: 7px;
                    margin-right: 4px;
                }
                a{
                    font-size: 13px;
                    line-height: 12px;
                    color: #fff;
                    vertical-align: middle;
                    font-weight: 400;
                    font-family: "Microsoft Yahei",latolight,Arial,"Helvetica Neue",Helvetica,Arial,sans-serif;
                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
            .online_service{
                position: relative;
                height: 100%;
                background: #fbc300;
                margin-left: -2px;
                width: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                .hold_link{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                }
            }
            .weibo{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 30px;
                height: 100%;
                background: #f0f0f0;
                margin-left: 0;
                cursor: pointer;
                .wb-img1{
                    display: block;
                }
                .wb-img2{
                    display: none;
                }
                &:hover{
                    background: #CD270C;
                    .wb-img1{
                        display: none;
                    }
                    .wb-img2{
                        display: block;
                    }
                }
            }
            .weixin{
                position: relative;
                //width: auto;
                width: 30px;
                height: 100%;
                background: #f0f0f0;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 0;
                border-bottom-right-radius: 4px;
                border-top-right-radius: 4px;
                cursor: pointer;
                &.weixinHover {
                  &:hover {
                    background-color: #f0f0f0;
                    .wx-img1{
                      display: block;
                    }
                  }
                }
                .wx-img1{
                    display: block;
                }
                .wx-img2{
                    display: none;
                }
                .qrCode_container{
                    position: absolute;
                    display: none;
                    top: 40px;
                    left: -45px;
                    width: 144px;
                    height: 150px;
                    z-index: 1111;
                    background-color: #fff;
                    -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
                    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
                    text-align: center;
                    .service_code{
                        border-right: 1px dotted #dbdbdb;
                        img{
                            position: relative;
                            width: 100px;
                            top: 10px;
                            left: 0px;
                        }
                        p{
                            margin-top: 20px;
                            color: #000f57;
                        }
                    }
                }
                &:hover{
                    background: #69AB3D;
                    .wx-img1{
                        display: none;
                    }
                    .wx-img2{
                        display: block;
                    }
                    .qrCode_container{
                        display: block;
                    }
                }
            }
        }
        .nav_login{
            height: 74px;
            width: auto;
            .hasLogin{
                position: relative;
                padding-top: 21px;
                margin-left: 5px;
                height: 100%;
                .loginLogo{
                    width: 34px;
                    margin-right: 5px;
                    vertical-align: middle;
                    cursor: pointer;
                }
                .loginId{
                    position: relative;
                    display: inline-block;
                    max-width: 85px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    vertical-align: middle;
                    color: #0073bb;
                }
                .inactiveArrow{
                    display: inline-block;
                    vertical-align: middle;
                    width: 8px;
                    margin-left: 8px;
                    transform: rotateZ(0deg);
                    -webkit-transform: rotateZ(0deg);
                    -moz-transform: rotateZ(0deg);
                    -o-transform: rotateZ(0deg);
                    -ms-transform: rotateZ(0deg);
                }
                .loginMenu{
                    position: absolute;
                    display: none;
                    top: 68px;
                    left: 50%;
                    z-index: 999;
                    width: max-content;
                    height: auto;
                    text-align: left;
                    font-size: 14px;
                    color: white;
                    background-color: rgba(42,121,190, 0.95);
                    border-top: none;
                    border-bottom: none;
                    border-radius: 5px;
                    transform: translateX(-50%);
                    -webkit-transform: translateX(-50%);
                    -moz-transform: translateX(-50%);
                    -o-transform: translateX(-50%);
                    -ms-transform: translateX(-50%);
                    .arrow{
                        position: absolute;
                        width: 0;
                        height: 0;
                        top: -15px;
                        left: 50%;
                        &::after{
                            content: "";
                            position: absolute;
                            display: block;
                            width: 0;
                            height: 0;
                            border-color: transparent;
                            border-style: solid;
                            top: 0;
                            margin-left: -4px;
                            border-top-width: 0;
                            border-width: 8px;
                            border-bottom-color: #2A79BE;
                        }
                    }
                    ul{
                        padding: 4px 0;
                        li{
                            position: relative;
                            padding: 10px 15px;
                            color: #1174b8;
                            text-align: left;
                            cursor: pointer;
                            font-size: 0;
                            white-space: nowrap;
                            .loginIcon{
                                position: relative;
                                width: 18px;
                                display: inline-block;
                                vertical-align: middle;
                                img{
                                    filter: brightness(0) invert(1);
                                }
                            }
                            .rewardIcon {
                                width: 22px;
                                position: relative;
                                left: -2px;
                            }
                            p{
                                display: inline-block;
                                vertical-align: middle;
                                margin-bottom: 0;
                                color: #fff;
                                font-size: 13px;
                                margin-left: 8px;
                                white-space: nowrap;
                            }
                            a{
                                display: block;
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                height: 100%;
                            }
                            &:hover{
                                background-color: #54a3de;
                            }
                        }
                    }
                }
                &:hover{
                    .loginMenu{
                        display: block;
                    }
                    .inactiveArrow{
                        transform: rotateZ(180deg);
                        -webkit-transform: rotateZ(180deg);
                        -moz-transform: rotateZ(180deg);
                        -o-transform: rotateZ(180deg);
                        -ms-transform: rotateZ(180deg);
                    }
                }
            }

        }
    }
</style>
